// Counter-pattern helpers for number hyperparameters written as `N++` / `N--`.
//
// At runtime (api buildCustomParams) a value like "1++" makes the param a
// per-call counter: it starts at 0 and adds the step (1) on every call, so
// after `callCount` calls it resolves to `step * callCount`. "1--" decrements.
//
// These helpers keep the canvas node chip and the sidebar param input showing
// the IDENTICAL preview, so there's one source of truth for how a counter
// reads on screen.

// Returns { step, isIncrement } when `value` is exactly a counter pattern
// ("1++" / "5--"), otherwise null.
function parseIncrementPattern(value) {
  var str = String(value === undefined || value === null ? '' : value);
  var incr = str.match(/^(\d+)\+\+$/);
  var decr = !incr ? str.match(/^(\d+)--$/) : null;
  if (!incr && !decr) return null;
  return { step: Number((incr || decr)[1]), isIncrement: !!incr };
}

// Computed value string the counter resolves to, but ONLY once the node has
// actually run (call count > 0 and running/completed). Returns null otherwise,
// so callers show nothing before the first run — matching the canvas chip.
function getIncrementPreview(value, nodeCallCount, nodeStatus) {
  var pattern = parseIncrementPattern(value);
  if (!pattern) return null;
  var count = Number(nodeCallCount) || 0;
  var hasRun = count > 0 && (nodeStatus === 'running' || nodeStatus === 'completed');
  if (!hasRun) return null;
  var magnitude = pattern.step * count;
  return String(pattern.isIncrement ? magnitude : -magnitude);
}

module.exports = {
  parseIncrementPattern: parseIncrementPattern,
  getIncrementPreview: getIncrementPreview
};
